'use client';

import type { BlogFiltersProps } from '@routeroyal/theme-core';

export function RouteRoyalBlogFilters({
  categories,
  selectedCategory,
  onCategoryChange,
  sortOptions,
  sortBy = 'latest',
  onSortChange,
  className = '',
}: BlogFiltersProps) {
  const resolvedSortOptions = sortOptions || [
    { label: 'Latest', value: 'latest' },
    { label: 'Oldest', value: 'oldest' },
    { label: 'Popular', value: 'popular' },
  ];

  return (
    <div className={className}>
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
        <div className="flex flex-wrap items-center gap-2">
          <button
            onClick={() => onCategoryChange(undefined)}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-150 ${
              !selectedCategory
                ? 'bg-blue-900 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'
            }`}
          >
            All
          </button>
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => onCategoryChange(category)}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-150 ${
                selectedCategory === category
                  ? 'bg-blue-900 text-white'
                  : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'
              }`}
            >
              {category}
            </button>
          ))}
        </div>
        {onSortChange && (
          <div className="flex items-center gap-2">
            <label htmlFor="rr-blog-sort" className="text-sm text-gray-600 font-medium">Sort:</label>
            <select
              id="rr-blog-sort"
              value={sortBy}
              onChange={(e) => onSortChange(e.target.value)}
              className="pl-3 pr-8 py-2 bg-white border border-gray-200 rounded-md text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500"
            >
              {resolvedSortOptions.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>
        )}
      </div>
    </div>
  );
}
